import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero-page" }
const _hoisted_2 = { class: "d-flex justify-center align-center hero-icons" }
const _hoisted_3 = { class: "d-flex justify-center align-center hero-icons" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_img = _resolveComponent("v-img")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_img, {
        src: require('../assets/white-spotify.png'),
        class: "hyper mx-4",
        width: "40",
        height: "40",
        role: "button",
        "aria-label": "Open Spotify",
        onClick: _cache[0] || (_cache[0] = $event => ($options.openSpotify()))
      }, null, 8, ["src"]),
      _createVNode(_component_v_img, {
        src: require('../assets/white-apple.png'),
        class: "hyper mx-4",
        width: "40",
        height: "40",
        role: "button",
        "aria-label": "Open Apple Music",
        onClick: _cache[1] || (_cache[1] = $event => ($options.openApple()))
      }, null, 8, ["src"]),
      _createVNode(_component_v_img, {
        src: require('../assets/white-bc.png'),
        class: "hyper mx-4",
        width: "40",
        height: "40",
        role: "button",
        "aria-label": "Open Bandcamp",
        onClick: _cache[2] || (_cache[2] = $event => ($options.openBandcamp()))
      }, null, 8, ["src"]),
      _createVNode(_component_v_img, {
        src: require('../assets/white-soundcloud.png'),
        class: "hyper mx-4",
        width: "40",
        height: "40",
        role: "button",
        "aria-label": "Open SoundCloud",
        onClick: _cache[3] || (_cache[3] = $event => ($options.openSoundcloud()))
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_v_img, {
      src: require('../assets/FBC36.jpg'),
      class: "hero-image"
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_img, {
        src: require('../assets/white-fb.png'),
        class: "hyper mx-4",
        width: "40",
        height: "40",
        role: "button",
        "aria-label": "Open Facebook",
        onClick: _cache[4] || (_cache[4] = $event => ($options.openFacebook()))
      }, null, 8, ["src"]),
      _createVNode(_component_v_img, {
        src: require('../assets/white-ig.png'),
        class: "hyper mx-4",
        width: "40",
        height: "40",
        role: "button",
        "aria-label": "Open Instagram",
        onClick: _cache[5] || (_cache[5] = $event => ($options.openInstagram()))
      }, null, 8, ["src"]),
      _createVNode(_component_v_img, {
        src: require('../assets/white-yt.png'),
        class: "hyper mx-4",
        width: "40",
        height: "40",
        role: "button",
        "aria-label": "Open YouTube",
        onClick: _cache[6] || (_cache[6] = $event => ($options.openYoutube()))
      }, null, 8, ["src"]),
      _createVNode(_component_v_img, {
        src: require('../assets/white-twitter.png'),
        class: "hyper mx-4",
        width: "40",
        height: "40",
        role: "button",
        "aria-label": "Open Twitter",
        onClick: _cache[7] || (_cache[7] = $event => ($options.openTwitter()))
      }, null, 8, ["src"])
    ])
  ]))
}